import React from 'react';
import './button.css';
import { Link } from 'react-router';

// This button can act as a link if you provide an `href` prop.
export const Button = ({ children, onClick, href, className }) => {
  // If an href is provided, render an anchor tag styled as a button.
  if (href) {
    return (
      <Link to={href} className={className}>
        {children}
      </Link>
    );
  }

  // Otherwise, render a standard button.
  return (
    <button onClick={onClick} className={className}>
      {children}
    </button>
  );
};
